import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MensajeWhatsappService } from 'src/app/services/mensaje-whatsapp.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotFoundComponent implements OnInit {
  constructor(
    private title: Title,
    private meta: Meta,
    private mensajeWhatsappService: MensajeWhatsappService,
  ) {}

  ngOnInit(): void {
    this.title.setTitle('Página no encontrada | SOY iPhone');
    this.meta.updateTag({
      name: 'description',
      content:
        'La página que buscás no existe. Volvé al inicio o escribinos por WhatsApp.',
    });
    // El status 404 real lo pone server.ts — esto es la señal explícita
    // para los crawlers que sí llegan a leer el HTML, para que no la indexen.
    this.meta.updateTag({ name: 'robots', content: 'noindex, follow' });
  }

  enviarWhatsApp(): void {
    this.mensajeWhatsappService.enviarWhatsApp();
  }
}
